import {connect} from 'react-redux'
import {ActionsRow, commons, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as polozkaActions from "../../actions/polozkaActions";
import {FixedDropDownButton} from "@mc/mc-legacy";
const {sinkEvent} = commons;
import TablePanel from "../../components/TablePanel";
import PolozkaApi from "../../api/gen/cgo/PolozkaApi";
import * as EnumKodExterniPolozkaInfo from "../../api/EnumKodExterniPolozkaInfo";
import ParovaniFakturacniPolozkaForm from "../../forms/ParovaniFakturacniPolozkaForm";
import {withTranslation, WithTranslation} from "react-i18next";

const COLUMN_WIDTH = 2;

/**
 * Stránka administrace - Párování fakturačních položek
 */
class ParovaniFakturacnichPolozekPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(polozkaActions.fetchParovaniFakturacniPolozkyIfNeeded());
    };

    handleCreateParovani = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ParovaniFakturacniPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.createPolozkaParovani(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateParovaniFakturacniPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_pairing'),
            {size: "md"}
        ));
    };

    handleEditParovani = (polozkaParovani) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ParovaniFakturacniPolozkaForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.updatePolozkaParovani(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateParovaniFakturacniPolozky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: polozkaParovani
            },
            t('pairing_change'),
            {size: "md"}
        ));
    };

    renderContextMenu = (polozka) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditParovani.bind(this, polozka))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {parovaniPolozkyList, t} = this.props;

        let content;
        if (parovaniPolozkyList.fetched) {
            if (parovaniPolozkyList.rows.length !== 0) {
                content = parovaniPolozkyList.rows.map((polozka) => {
                    return <CardBody key={polozka.id}>
                        <ActionsRow actions={this.renderContextMenu(polozka)} onClick={sinkEvent(this.handleEditParovani.bind(this, polozka))}>
                            <Row>
                                <Col xs={COLUMN_WIDTH}>{EnumKodExterniPolozkaInfo.getCaption(polozka.kodExterniPolozka, t)}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.hranicePokryti}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.polozkaHranicePod.nazev}</Col>
                                <Col xs={COLUMN_WIDTH}>{polozka.polozkaHraniceNad.nazev}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_billing_item_pairing')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }

        return <AdminPage
            title={t('admin.billing_items_pairing')}
            subtitle={t('admin.system_operator_billing_items_pairing')}
            content={
                <div>
                    <ButtonToolbar>
                        {<Button color="primary" onClick={this.handleCreateParovani}>Nová</Button>}
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={COLUMN_WIDTH}>{t('labels.external_item_code')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('coverage_border')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.item_under_border')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.item_above_border')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        parovaniPolozkyList: utils.storeFromArea(state, polozkaActions.PAROVANI_POLOZKY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ParovaniFakturacnichPolozekPage));

